import React from 'react';
import { connect } from 'react-redux';
import Icon from 'views/Icon';
import MojoPopup from 'views/MojoPopup';
import { Row, Columns } from 'views/Grid';
import CopyToClipboard from 'react-copy-to-clipboard';
import ia from 'config/Analytics';
import Animate from 'views/Animate';
import Loading from 'views/Loading';
import root from 'window-or-global';
import { isIOS_Device } from 'config/utils';

import {
  getShortUrl,
  getShortUrlForm,
  getImagePreview,
  getOfferSlug,
  getOfferPathname,
  getIsUserOwner,
} from '../../reducers/ProductReducers';

import {
  FormFieldWithLabel as FormField,
} from 'views/FormComponents';

import {
  changeShortUrl,
  editShortUrl,
  changeIsShortUrlEditable,
  resetShortUrl,
} from '../../actions/ProductActions';

const handleClickedSharer = ({ slug, name }) => {
  ia.sendEvent('Shared Offer', {
    offer_id: slug,
    share_mode: name,
  });
};

const Sharer = ({ name, link, iconName, isDisabled, slug }) => {
  if (isDisabled) {
    return (
      <div>
        <div className={`share-sprite share-${iconName}`}></div>
        <div className="caps soft-half--top text-grey">{name}</div>
      </div>
    );
  }

  return(
    <a target="_blank" href={link} onClick={ () => handleClickedSharer({ slug, name })}>
      <div className={`share-sprite share-${iconName}`}></div>
      <div className="caps soft-half--top">{name}</div>
    </a>
  );
};

class ShareBlock extends React.Component {
  constructor () {
    super();
    this.state = {
      isModalOpen: false,
      isCopied: false,
    };
  }

  closePopup () {
    this.setState({ isModalOpen: false });
    this.cancelEditingShortUrl();
  }

  openPopup () {
    this.setState({ isModalOpen: true });
  }

  editShareLink (e) {
    e.stopPropagation();
    this.props.changeIsShortUrlEditable(true);
  }

  cancelEditingShortUrl () {
    this.props.changeIsShortUrlEditable(false);
    this.props.resetShortUrl();
  }

  _renderPopupContent () {
    const {
      shortUrl,
      shortUrlForm,
      preview,
      slug,
      offerPathname,
      isUserOwner,
    } = this.props;
    const { isRequesting, isEditing, shortUrlIdentifier, errors } = shortUrlForm;
    const shareText = 'Hi! You can pay me with Instamojo, just use this link - ';

    let shareUrl = shortUrl != 'None' ? shortUrl : `${root.location.origin}${offerPathname}`;

    const shareTextWithLink = `Hi! You can pay me with Instamojo, just use this link - ${shareUrl}`;
    return (
      <div className="share-content push-half--ends">
        <span className="soft--sides">SHARE VIA...</span>
        <hr className="push--top popup-separator" />
        <Row>
          <Columns className="small-4 text-center soft--bottom show-for-small-only">
            <Sharer
              name="whatsapp"
              link={`whatsapp://send?text=${encodeURIComponent(shareTextWithLink)}`}
              iconName="whatsapp"
              slug={slug}
            />
          </Columns>
          <Columns className="small-4 text-center soft--bottom show-for-small-only">
            <Sharer
              name="sms"
              link={`sms:${isIOS_Device ? '&' : '?'}body=${encodeURIComponent(shareTextWithLink)}`}
              iconName="sms"
              slug={slug}
            />
          </Columns>
          <Columns className="small-4 text-center soft--bottom">
            <Sharer
              name="facebook"
              link={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
              iconName="fb"
              slug={slug}
            />
          </Columns>
          <Columns className="small-4 text-center soft--bottom">
            <Sharer
              name="twitter"
              link={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`}
              iconName="twitter"
              slug={slug}
            />
          </Columns>
          {/* <Columns className="small-4 text-center soft--bottom">
            <Sharer
              name="instagram"
              link=""
              iconName="instagram"
              slug={slug}
            />
          </Columns> */}
          <Columns className="small-4 text-center soft--bottom end">
            <Sharer
              name="pinterest"
              link={`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&media=${preview}&description=${encodeURIComponent(shareTextWithLink)}`}
              iconName="pinterest"
              slug={slug}
            />
          </Columns>
        </Row>
        <div className="show-for-medium">
          <div className="soft--sides soft--top soft-half--bottom caps text-grey">
            Available Only on Mobile
          </div>
          <Row className="soft--top">
            <Columns className="small-4 text-center soft--bottom">
              <Sharer
                name="whatsApp"
                link={`whatsapp://send?text=${encodeURIComponent(shareTextWithLink)}`}
                iconName="whatsapp-disabled"
                isDisabled={true}
                slug={slug}
              />
            </Columns>
            <Columns className="small-4 text-center soft--bottom end">
              <Sharer
                name="sms"
                link={`sms:${isIOS_Device ? '&' : '?'}body=${encodeURIComponent(shareTextWithLink)}`}
                iconName="sms-disabled"
                isDisabled={true}
                slug={slug}
              />
            </Columns>
          </Row>
        </div>
        <hr className="popup-separator push--ends" />
        {
          !isEditing ?
          <CopyToClipboard
            text={shareUrl}
            onCopy={() => {
              this.setState({ isCopied: true });
              setTimeout(() => {
                this.setState({ isCopied: false });
              }, 2000);
            }}>
            <div className="soft--sides">
              <span
                title={shareUrl}
                style={{ maxWidth: '150px', display: 'inline-block', lineHeight: '1.2' }}
                className="text-overflow-ellipsis">
                {shareUrl}
              </span>
              { isUserOwner ?
                <a>
                  <span className="caps pull-right push--left" onClick={ (e) => this.editShareLink(e)}>Customize</span>
                </a> :
                null
              }
              {this.state.isCopied ?
                <span className="caps pull-right text-green">Copied</span> :
                <span><a className="caps pull-right">Copy Link</a></span>
              }
            </div>
          </CopyToClipboard> :
          <Animate>
            <FormField className="soft--sides no-list" errors={errors.identifier}>
              <Row className="collapse prefix-radius postfix-radius">
                <Columns className="small-4">
                  <span className="prefix share-content">http://imojo.in/</span>
                </Columns>
                <Columns className="small-5">
                  <input type="text"
                    className="share-content flush"
                    value={shortUrlIdentifier}
                    onChange={(e) => this.props.editShortUrl(e.target.value)}
                    autoFocus={true}
                    />
                </Columns>
                <Columns className="small-3">
                  <button
                    className="postfix postfix-stick-left btn postfix-button share-content hard--sides text-blue"
                    onClick={() => this.props.changeShortUrl()}>
                    { isRequesting ?
                      <Loading style={{ marginTop: '1px' }}/> :
                      'Change'
                    }
                  </button>
                </Columns>
              </Row>
            </FormField>
            <div className="text-center strong caps soft-half--top" style={{ textDecoration: 'underline' }}>
              <a onClick={() => this.cancelEditingShortUrl()}>
                Back
              </a>
            </div>
          </Animate>
        }
      </div>
    );
  }

  render () {
    return (
      <span>
        <span
          className="caps strong"
          style={{ color: '#3B96E0', cursor: 'pointer' }}
          onClick={() => this.openPopup()}>
          <Icon className="ui-2_share-bold" />Share
        </span>
        <MojoPopup
          show={this.state.isModalOpen}
          onClose={() => this.closePopup()}>
          {this._renderPopupContent()}
        </MojoPopup>
      </span>
    );
  }
}

const mapStateToProps = ({ product }) => ({
  shortUrl: getShortUrl(product),
  shortUrlForm: getShortUrlForm(product),
  preview: getImagePreview(product),
  slug: getOfferSlug(product),
  offerPathname: getOfferPathname(product),
  isUserOwner: getIsUserOwner(product),
});

export default connect(mapStateToProps, {
  changeShortUrl,
  editShortUrl,
  changeIsShortUrlEditable,
  resetShortUrl,
})(ShareBlock);



// WEBPACK FOOTER //
// ./src/product/views/_layout/ShareBlock.js